// The last store a signed-out visitor looked at (Phase 49, D-21). A signup that opened from a
// context-free surface (nav, leaderboard) still sends this slug as `lastViewedStoreSlug`, so the
// onboarding messages can be about a concrete store. Client-only: every access is guarded, and
// both functions are no-ops on the server. The value is user-editable, so it is validated on read
// and write; the backend parser (plan 06) is still the authority.
import { STORE_SLUG_RE } from "@shared/onboarding";

const LAST_VIEWED_STORE_KEY = "ys_last_viewed_store";

export const writeLastViewedStore = (slug: string | undefined | null): void => {
  if (typeof window === "undefined") return;
  if (!slug || !STORE_SLUG_RE.test(slug)) return;
  try {
    window.localStorage.setItem(LAST_VIEWED_STORE_KEY, slug);
  } catch {
    // Storage disabled or full: losing the hint is harmless.
  }
};

export const readLastViewedStore = (): string | undefined => {
  if (typeof window === "undefined") return undefined;
  try {
    const value = window.localStorage.getItem(LAST_VIEWED_STORE_KEY);
    return value && STORE_SLUG_RE.test(value) ? value : undefined;
  } catch {
    return undefined;
  }
};
